const transportTypes = {
  NO_ES_NECESARIO: '261',
  REGULAR: '139',
  PORTEADOR: '141',
  BECA: '140',
};

export default transportTypes;
